import Vue from 'vue'
import Router from 'vue-router'
import $store from "../store"

import Home from '../components/index'
import Free from '../components/free'

import Login from '../components/login'
import Ball from '../components/ball'
import Dan from '../components/dan'
import Coupon from '../components/coupon'
import Expert from '../components/expert'
import Expert_View from '../components/expert_view'
import Match from '../components/match'
import Cart from '../components/cart'
import Register from '../components/register'

import My from '../components/my'
import MyInfo from '../components/account/info'
import MySubscribe from '../components/account/subscribe'
import MyCoupon from '../components/account/coupon'
import MyCost from '../components/account/cost'
import MyCharge from '../components/account/recharge'

import Help from '../components/about/help'
import About from '../components/about/about'
import Contact from '../components/about/contact'
import Mainze from '../components/about/mianze'
import Treaty from '../components/about/treaty'

import News_View from '../components/news_view'
import News_List from '../components/news_list'

import None from '../components/none'

const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}

Vue.use(Router)


let router = new Router({
  mode: 'history',
  // scrollBehavior(to, from, savedPosition) {
  //   return new Promise((resolve) => {
  //     if(savedPosition){
  //       setTimeout(() => {
  //         resolve(savedPosition)
  //       }, 50)
  //     }
  //   })
  // },
  routes: [
    //{path:'*', name: '404', redirect: '/404'},
    {path:'/', name: 'index', component: Home, meta: {footer: true}}, //title: '首页'
    {path:'*', name: 'none', component: None, meta: {footer: true, title: '找不到内容'}},
    {path:'/news/:name', name: 'news_list', component: News_List, meta: {footer: false}}, //, title: '新闻类别'
    {path:'/news/v/:id', name: 'news_view', component: News_View, meta: {footer: false}}, //, title: '新闻详情'
    {path:'/free', name: 'free', component: Free, meta: {footer: true, header: false, title: '预测', pageIndex: 2}},

    {path:'/football', name: 'ball', component: Ball, meta: {footer: true, header: false, ball: 1, title: '足球预测'}},
    {path:'/baskball', name: 'ball', component: Ball, meta: {footer: true, header: false, ball: 2, title: '篮球预测'}},
    {path:'/ball', name: 'ball', component: Ball, meta: {footer: true, header: false, title: '预测'}},
    {path:'/football/dan', name: 'football', component: Dan, meta: {footer: false, ball: 1, title: '足球单场'}},
    {path:'/baskball/dan', name: 'baskball', component: Dan, meta: {footer: false, ball: 2, title: '篮球单场'}},
    {path:'/coupon', name: 'coupon', component: Coupon, meta: {footer: true, header: false, title: '优惠'}},
    {path:'/expert', name: 'expert', component: Expert, meta: {footer: true, header: false, title: '专家'}},
    {path:'/expert/:name', name: 'expert', component: Expert_View, meta: {footer: false, header: false, title: '专家'}},
    {path:'/match/:id', name: 'match', component: Match, meta: {footer: false, header: false, title: '赛事精选'}},
    {path:'/cart', name: 'cart', component: Cart, meta: {auth: true, footer: false, header: false, title: '购物车', reload: true}},


    {path:'/login',name: 'login', component: Login, meta:{footer: true, header: false,title: '登录'}},
    {path:'/register', name: 'register', component: Register, meta:{footer: true, header: false,title: '注册'}},

    {path:'/help', name: 'help', component: Help, meta: {footer: false, header: false, title: '帮助'}},
    {path:'/contact', name: 'contact', component: Contact, meta: {footer: false, header: false, title: '联系我们'}},
    {path:'/about', name: 'about', component: About, meta: {footer: false, header: false, title: '关于我们'}},
    {path:'/mianze', name: 'mianze', component: Mainze, meta: {footer: false, header: false, title: '免责声明'}},
    {path:'/treaty', name: 'treaty', component: Treaty, meta: {footer: false, header: false, title: '用户协议'}},


    {path:'/my',name: 'my',component: My,meta: {footer: true, header: false, title: '会员中心'}},
    {path:'/account/info',name: 'myinfo',component: MyInfo,meta: {auth: true, footer: false, header: false, title: '用户信息'}},
    {path:'/account/subscribe', name: 'mysubscribe', component: MySubscribe, meta: { auth: true, footer: false, header: false, title: '我的订阅'}},
    {path:'/account/coupon', name: 'mysale', component: MyCoupon, meta: {auth: true, footer: false, header: false, title: '我的优惠'}},
    {path:'/account/cost', name: 'mycost', component: MyCost, meta: {auth: true, footer: false, header: false, title: '交易记录'}},
    {path:'/account/recharge', name: 'recharge', component: MyCharge, meta: {auth: true, footer: false, header: false, title: '在线充值'}},
  ]
})
//验证路由
router.beforeEach((to, from, next) => {
  const {auth, header, footer, title} = to.meta
  // const {auth, title} = to.meta
  // console.log(from.path, to.path)
  if(to.name === 'login' && $store.state.token != null) {
    next({path:'/my'})
    return
  }
  if(to.name === 'register' && $store.state.token) {
    next({path:'/my'})
    return
  }
  if(to.name === 'match'){
    if(from.name !== 'match'){
      to.meta.path = from.path
    }
    // console.log(from.path, to.path)
    // if(from.path === to.path){
    //   to.path = to.path + '?' + new Date().getTime()
    // }
  }
  // if(to.meta.pageIndex) $store.commit("SET_PAGE", to.meta.pageIndex)
  let header0 = header
  if(header === undefined)
    header0 = true
  header0 === true ? $store.commit("SHOW_HEADER") : $store.commit("HIDE_HEADER")
  footer === true ? $store.commit("SHOW_FOOTER") : $store.commit("HIDE_FOOTER")
  //document.title = title+'-' || ''
  if(title)
    document.title = title + ' | 烽行体育贴士预测交易平台'
  else
    document.title = '足球分析师赛事预测,烽行体育足球贴士预测交易平台,篮球预测,贴士分析,篮球预测 | 烽行体育贴士预测交易平台'

  if(auth === true && $store.state.token == null){
    //if (from.name === "login") return
    console.log('要认证哦')
    next({path:'/login'})
  }

  next()
})

export default router
